import { render, staticRenderFns } from "./patchNotes.vue?vue&type=template&id=17c5d447&scoped=true"
import script from "./patchNotes.vue?vue&type=script&lang=js"
export * from "./patchNotes.vue?vue&type=script&lang=js"
import style0 from "./patchNotes.vue?vue&type=style&index=0&id=17c5d447&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c5d447",
  null
  
)

export default component.exports